export enum Icons {
   Navigation = 'navigation-icon',
   PhotoCamera = 'photo-camera',
   FACEBOOK = 'social-facebook',
   INSTAGRAM = 'social-insta',
  CHAT = 'chat-white'
}
